import axios from '../../../../api/axios';
import { toast } from 'react-toastify';

export const CHATBOT_ENDPOINTS = {
  GET_PUBLIC_CONFIG: '/v2/chat-bot/widget/config',
  GET_CONFIG_BY_SLUG: '/v2/chat-bot/widget/config/slug',
  SEND_MESSAGE: '/v2/chat-bot/widget/message',
  GET_CONFIGS: '/v2/chat-bot/configs',
  GET_CONFIG_BY_ID: '/v2/chat-bot/configs',
  CREATE_CONFIG: '/v2/chat-bot/configs',
  UPDATE_CONFIG: '/v2/chat-bot/configs',
  DELETE_CONFIG: '/v2/chat-bot/configs',
  GET_LEADS: '/v2/chat-bot/leads',
  UPDATE_LEAD_STATUS: '/v2/chat-bot/leads',
  GET_ANALYTICS: '/v2/chat-bot/analytics',
};

const handleApiError = (error, defaultMessage) => {
  const message =
    error.response?.data?.message ||
    error.message ||
    defaultMessage ||
    'An unexpected error occurred';
  console.error(defaultMessage, error);
  toast.error(message);
  throw new Error(message);
};

export const getChatbotPublicConfig = async (token) => {
  try {
    const response = await axios.get(`${CHATBOT_ENDPOINTS.GET_PUBLIC_CONFIG}/${token}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to load chatbot config');
  }
};

export const getChatbotPublicConfigBySlug = async (chatSlug) => {
  try {
    const response = await axios.get(`${CHATBOT_ENDPOINTS.GET_CONFIG_BY_SLUG}/${chatSlug}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to load chatbot config');
  }
};

export const sendChatbotMessage = async (payload) => {
  try {
    const response = await axios.post(CHATBOT_ENDPOINTS.SEND_MESSAGE, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to send message');
  }
};

export const getChatbotConfigs = async () => {
  try {
    const response = await axios.get(CHATBOT_ENDPOINTS.GET_CONFIGS);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch chatbot configs');
  }
};

// New function: fetch a single config by ID
export const getChatbotConfigById = async (configId) => {
  try {
    const response = await axios.get(`${CHATBOT_ENDPOINTS.GET_CONFIG_BY_ID}/${configId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch chatbot config');
  }
};

export const createChatbotConfig = async (payload) => {
  try {
    const response = await axios.post(CHATBOT_ENDPOINTS.CREATE_CONFIG, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to create chatbot config');
  }
};

export const updateChatbotConfig = async (configId, payload) => {
  try {
    const response = await axios.put(`${CHATBOT_ENDPOINTS.UPDATE_CONFIG}/${configId}`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update chatbot config');
  }
};

export const deleteChatbotConfig = async (configId) => {
  try {
    const response = await axios.delete(`${CHATBOT_ENDPOINTS.DELETE_CONFIG}/${configId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to delete chatbot config');
  }
};

export const getChatbotLeads = async (params = {}) => {
  try {
    const response = await axios.get(CHATBOT_ENDPOINTS.GET_LEADS, { params });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch chatbot leads');
  }
};

export const updateChatbotLeadStatus = async (leadId, status) => {
  try {
    const response = await axios.patch(`${CHATBOT_ENDPOINTS.UPDATE_LEAD_STATUS}/${leadId}/status`, { status }, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update lead status');
  }
};

export const getChatbotAnalytics = async () => {
  try {
    const response = await axios.get(CHATBOT_ENDPOINTS.GET_ANALYTICS);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch chatbot analytics');
  }
};